import { Link } from '@algoacademy/design-system/web/actions/Link'
import { ArrowRightIcon } from '@heroicons/react/24/solid'
import { cn } from '@/app/_lib/utils'

type SeeMoreButtonProps = {
  href: string
  handleOnClick?: () => void
  title: string
  className?: string
}

export function ReadMoreButton({ href, handleOnClick, title, className }: SeeMoreButtonProps) {
  return (
    <Link href={href} onClick={handleOnClick} className='flex flex-row items-center gap-x-2'>
      <p className={cn('font-semibold text-algoprimary', className)}>{title}</p>
      <ArrowRightIcon className='h-4 w-4 text-algoprimary' />
    </Link>
  )
}
